module.exports = __webpack_public_path__ + "img/black.3651570a.png";